export interface GeneralResponse<T> {
    success?: boolean;
    message?: string ;
    status?: EResponseStatus;
    resource: T ;
    data?:T
}
export interface PaginatedList<T> {
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    readonly hasPreviousPage?: boolean;
    readonly hasNextPage?: boolean;
    items: T[];
}
export enum EResponseStatus {
    Invalid = "Invalid",
    Succeed = "Succeed",
    Exception = "Exception",
}
export interface ErrorResponse{
    error:GeneralResponse<any>
    status:number,
    statusText:string
}
export enum EUserType
    {
        Admin = 0,
        Investor = 1,
        FundManager = 2,
    }


    export enum EUserRole
    {
        Admin = 0,
        BusinessDeveloper = 1,
        Compliance = 2,
        Operation = 3,
        Ceo = 4,
        OperationsManager = 5,
        FundManager = 6,
    }
    export enum EInvestorDegreeType {
        Retail = "Retail",
        Qualified = "Qualified",
        Institutional = "Institutional",
    }
    export enum EInvestorType {
        Individual = "Individual",
        Company = "Company",
    }